import {inject, Injectable} from '@angular/core';
import {AppStore} from '../store/app.store';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private store = inject(AppStore);
  get = (key: string) => this.store.getSetting()(key);
}
